import React from "react";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addItem } from "./store.js";
import { Link } from "react-router-dom";
// 기능들

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/pagination";
import { Pagination } from "swiper";
import "swiper/css";
// 스와이퍼

import Form from "react-bootstrap/Form";
import { Nav } from "react-bootstrap";
// 부트스트랩

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";


function Product(props) {
  let { id } = useParams(); // 사이트 주소 파라미터 값& 해당 상품의 사이트

  const [product, setProduct] = useState(null); //누른 상품이 올 자리

  let [tap, setTap] = useState(0);

  let dispatch = useDispatch();
  // 스토어에서 함수 불러옴.

  useEffect(() => {
    // id를 사용하여 상품 정보 가져옴
    const GetProduct = props.seller.find((item) => item.id === parseInt(id)); //seller의 id와 파라미터로 갖고온 상품의 id를 비교함. 그리고 일치한 id가 있는 데이터를 모두 GetProduct에 담음. =메인에서 내가 누른 값이 담김.
    setProduct(GetProduct); //빈 공간을 갖고온 상품의 데이터로 채움.
  }, [id, setProduct]); //id의 값과 상품 변수가 바뀔 때마다 useEffect 실행.

  if (!product) {
    /*변수의 값이 null일 때 if문으로 없을 경우에 대한 경우를 적어야함.*/
    return <div>Loading...</div>;
  }

  return (
    <div className="start ex">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <Swiper
              spaceBetween={30}
              pagination={{
                clickable: true,
              }}
              modules={[Pagination]}
              className="mySwiper"
            >
              <SwiperSlide>
                <img
                  src={"/img/top_seller/" + product.imgUrl} //내가 입력한 값의 seller가 나옴
                  width="100%"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={"/img/top_seller/" + product.imgUrl2} //내가 입력한 값의 seller가 나옴
                  width="100%"
                />
              </SwiperSlide>
            </Swiper>
          </div>

          <div className="col-md-6">
            <div className="productBox">
              <div className="pro_info">
                <div className="Title_box">
                  <h2>{product.title}</h2>
                </div>
                {/* 상품명 */}

                <div className="Price_box">
                  <h1>{product.price}원</h1>
                </div>
                {/* 가격 */}

                <div className="Version_box">
                  <h3>Color</h3>
                  <ul>
                    <li className="thumb">
                      <img src="/img/pro_mini_clothes1.jpg" />
                    </li>
                    <li className="thumb">
                      <img src="/img/pro_mini_clothes2.jpg" />
                    </li>
                    <li className="thumb">
                      <img src="/img/pro_mini_clothes3.jpg" />
                    </li>
                  </ul>
                </div>
              </div>

              <div className="pro_option">
                <table>
                  <tr>
                    <th>사이즈</th>
                    <td>
                      <Form.Select
                        aria-label="Default select example"
                        style={{ width: "100%" }}
                      >
                        <option>- [필수] SELECT OPTION -</option>
                        <option>--------------------------</option>
                        <optgroup label="사이즈">
                          <option value="1">S</option>
                          <option value="2">M</option>
                          <option value="3">L</option>
                        </optgroup>
                      </Form.Select>
                    </td>
                  </tr>
                </table>
              </div>

              <h5>(최소주문수량 1개이상)</h5>

              <div className="Btn_Box">
                <button
                  type="button"
                  class="btn btn-success"
                  onClick={() => {
                    dispatch(
                      addItem({
                        id: product.id,
                        code: product.code,
                        imgUrl: product.imgUrl,
                        name: product.title,
                        count: 1,
                      })
                    );
                  }}
                >
                  BUY IT NOW
                </button>

                <Link to="/cart">
                  <button type="button" class="btn btn-outline-success">
                    CART
                  </button>
                </Link>

                <Link to="/cart">
                  <button
                    type="button"
                    class="btn btn-outline-light"
                    style={{ border: "1px solid #ddd" }}
                  >
                    WISH LIST
                  </button>
                </Link>
              </div>
            </div>
          </div>

          {/* row */}
        </div>

        {/* <Nav fill variant="tabs" className="NavTabs">
          <Nav.Item>
            <Nav.Link  eventKey="link-1">상세정보</Nav.Link>
          </Nav.Item>

          <Nav.Item>
            <Nav.Link eventKey="link-2">
              상품후기<span className="reviewNum">26</span>
            </Nav.Link>
          </Nav.Item>

          <Nav.Item>
            <Nav.Link eventKey="link-3">배송/교환/반품</Nav.Link>
          </Nav.Item>
        </Nav> */}

        <Nav
          variant="tabs"
          defaultActiveKey="link0"
          style={{ marginTop: "100px" }}
        >
          <Nav.Item style={{ width: "33%", textAlign: "center" }}>
            <Nav.Link
              onClick={() => {
                setTap(0);
              }}
              eventKey="link0"
            >
              상세정보
            </Nav.Link>
          </Nav.Item>

          <Nav.Item style={{ width: "33%", textAlign: "center" }}>
            <Nav.Link
              onClick={() => {
                setTap(1);
              }}
              eventKey="link1"
            >
              상품후기
            </Nav.Link>
          </Nav.Item>

          <Nav.Item style={{ width: "33%", textAlign: "center" }}>
            <Nav.Link
              onClick={() => {
                setTap(2);
              }}
              eventKey="link2"
            >
              배송/교환/반품
            </Nav.Link>
          </Nav.Item>
        </Nav>


        {/* 누르는 버튼에 따라 내용 뜸 */}
        <TabContent tap={tap} product={product}></TabContent>

        {/* container */}
      </div>
    </div>
  );
}




// 요소 나타나게 하는 전체 컴포넌트
function TabContent(props) {
  return [
    // 상품 상세정보
    <div className="container subImgProd">
      <div className="col-md-12">
        <div style={{ width: "900px", margin: "80px auto" }}>
          <img
            src="/img/sub_product/sub_img_01.jpg"
            style={{ cursor: "pointer" }}
          />

          <img src="/img/sub_product/sub_img_02_MB_banner.jpg" />

          <img src={"/img/sub_product/" + props.product.subImgProd1} />

          <img src={"/img/sub_product/" + props.product.subImgProd2} />

          <img src={"/img/sub_product/" + props.product.subImgProd3} />

          <img src={"/img/sub_product/" + props.product.subImgProd4} />

          <img src={"/img/sub_product/" + props.product.subImgProd5} />

          <img src="/img/sub_product/sub_img_03_clean_tip.jpg" />

          <img src="/img/sub_product/sub_img_04_malbon.jpg" />

          <img src="/img/sub_product/sub_img_05_malbon_delivery.jpg" />
        </div>
      </div>
    </div>,

    <ProReview />,

    <Delivery />,
  ][props.tap];
}







// 상품후기 컴포넌트
function ProReview() {
  return (
    <div className="container" style={{ padding: 0 }}>
      <div className="col-md-12">
        <div className="reviewBox">
          <div className="review_title">
            <p>
              REVIEW &nbsp;
              <span> &nbsp;| &nbsp;&nbsp; 상품의 사용후기를 적어주세요.</span>
            </p>
          </div>

          <div className="review_point">
            <div className="pro_Satisfaction">
              <h5>상품만족도</h5>
              <h4>
                <span class="star">★</span> 4.9 <span className="grey">/5</span>
              </h4>
              <p>
                <span>29</span> 개의 리뷰가 있습니다.{" "}
              </p>
            </div>

            <div className="right_line"></div>

            {/* 점수 스탯 */}
            <div className="pro_stats">
              <div className="widget_stats">
                <div className="widget_stats_item">
                  <div
                    className="widget_stats_bar"
                    style={{ backgroundColor: "#333336" }}
                  ></div>
                  <div className="widget_stats_text_1">5점</div>
                  <div className="widget_stats_text_2">97%</div>
                </div>

                <div className="widget_stats_item">
                  <div className="widget_stats_bar"></div>
                  <div className="widget_stats_text_1">4점</div>
                  <div className="widget_stats_text_2">0%</div>
                </div>

                <div className="widget_stats_item">
                  <div className="widget_stats_bar">
                    <div></div>
                  </div>
                  <div className="widget_stats_text_1">3점</div>
                  <div className="widget_stats_text_2">3%</div>
                </div>

                <div className="widget_stats_item">
                  <div className="widget_stats_bar"></div>
                  <div className="widget_stats_text_1">2점</div>
                  <div className="widget_stats_text_2">0%</div>
                </div>

                <div className="widget_stats_item">
                  <div className="widget_stats_bar"></div>
                  <div className="widget_stats_text_1">1점</div>
                  <div className="widget_stats_text_2">0%</div>
                </div>
              </div>
            </div>

            <div className="right_line"></div>

            <div className="pro_survey">
              <h2>키</h2>
              <div className="surveyBox">
                <div className="overFlowBox">
                  <div className="survey_choice">
                    158~161 33.3% (2명)
                    <div className="survey_select1"></div>
                  </div>

                  <div className="survey_choice">
                    162~165 33.3% (2명)
                    <div className="survey_select2"></div>
                  </div>

                  <div className="survey_choice">
                    154~157 16.7% (1명)
                    <div className="survey_select3"></div>
                  </div>

                  <div className="survey_choice">
                    166~169 16.7% (1명)
                    <div className="survey_select4"></div>
                  </div>
                </div>
              </div>
            </div>

            <div className="right_line"></div>

            <div className="pro_share">
              <h3>당신의 경험을 공유해주세요!</h3>
              <div className="reviewBtn">리뷰 작성하기</div>
            </div>
          </div>

          <div className="photo_review">
            <span>포토리뷰</span>
            <span>포토리뷰 모아보기</span>
          </div>

          <div className="container" style={{ padding: 0 }}>
            <div className="row">
              <div className="col-md-3">
                <div className="photo_reviewBox">
                  <div className="photo_Box">
                    <img src="/img/review/review1.jpeg" />
                  </div>
                  <div className="photo_Text">
                    <div className="starBox">
                      ★★★★★ <span>S</span>
                    </div>
                    <div className="photo_review_TextBox">
                      <h5>
                        부드럽고 사이즈 좋고 너무 예쁘네요 봄 여름 잘 입을 것
                        같아요
                      </h5>
                      <p>
                        ID <span>rlaquf**</span> <span>05.29</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="photo_reviewBox">
                  <div className="photo_Box">
                    <img src="/img/review/review2.jpg" />
                  </div>

                  <div className="photo_Text">
                    <div className="starBox">
                      ★★★★★ <span>L</span>
                    </div>
                    <div className="photo_review_TextBox">
                      <h5>
                        평소에는 M을 입는데 L로 주문했더니 살짝 여유있게 맞아요
                      </h5>
                      <p>
                        ID <span>mumu123...</span> <span>05.12</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="photo_reviewBox">
                  <div className="photo_Box">
                    <img src="/img/review/review3.jpeg" />
                  </div>
                  <div className="photo_Text">
                    <div className="starBox">
                      ★★★★★ <span>S</span>
                    </div>
                    <div className="photo_review_TextBox">
                      <h5>
                        만족할 만큼 좋은 상품이에요😍 감사합니다.
                      </h5>
                      <p>
                        ID <span>portfol...</span> <span>04.23</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="photo_reviewBox"></div>
              </div>
            </div>
          </div>


          {/* 상품평수 */}
          <div className="container" style={{marginTop:"50px"}}>
            <div className="pro_searchBox" style={{position:"relative", width:"300px", display:"flex" , alignItems:"center"}}>
              <span style={{fontSize:"13px", fontWeight:"bold" ,marginRight:"10px"}}>상품평수</span>
              <span style={{fontSize:"13px", marginRight:"40px"}}>29개</span>
              <input type="text" value="" style={{width:"160px",backgroundColor:"#f6f7f8", border:"solid 1px #eaeaea", position:"relative"}}></input>
              <FontAwesomeIcon icon={faMagnifyingGlass} style={{position:"absolute", top:5, right:15, cursor:"pointer"}}/>
            </div>
          </div>


          {/* 댓글리뷰달기 */}
          <ReivewComment></ReivewComment>


          {/*큰 리뷰 박스 */}
        </div>
      </div>
    </div>
  );
}



// 배송/교환/반품 컴포넌트
function Delivery() {
  return (
    <div className="container" style={{ marginBottom: "100px" }}>
      <div className="col-md-12">
        <div className="info_box">
          <h3>PAYMENT INFO</h3>
          <div className="txt_info_box">
            <span>
              고액결제의 경우 안전을 위해 카드사에서 확인전화를 드릴 수도
              있습니다. 확인과정에서 도난 카드의 사용이나 타인 명의의 주문등
              정상적인 주문이 아니라고 판단될 경우 임의로 주문을 보류 또는
              취소할 수 있습니다.
              <br />
              <br />
              무통장 입금은 상품 구매 대금은 PC뱅킹, 인터넷뱅킹, 텔레뱅킹 혹은
              가까운 은행에서 직접 입금하시면 됩니다.
              <br />
              주문시 입력한 입금자명과 실제입금자의 성명이 반드시 일치하여야
              하며, 7일 이내로 입금을 하셔야 하며 입금되지 않은 주문은 자동취소
              됩니다.
            </span>
          </div>

          <h3>DELIVERY INFO</h3>
          <div className="txt_info_box">
            배송 방법 : 택배 <br />
            배송 지역 : 전국지역 <br />
            배송 비용 : 무료 <br />
            배송 기간 : 3일 ~ 5일 <br />
            배송 안내 :
          </div>

          <h3>EXCHANGE INFO</h3>
          <div className="txt_info_box">
            <span>
              <strong>
                교환 및 반품 주소 <br />{" "}
              </strong>
              - [15657] 경기도 안산시 단원구 시화호수로 835 (성곡동) 로지스밸리
              3층
              <strong>
                <br />
                <br />
                교환 및 반품이 가능한 경우 <br />
              </strong>
              - 상품을 공급 받으신 날로부터 7일이내 단, 가전제품의 <br />
              &nbsp; 경우 포장을 개봉하였거나 포장이 훼손되어 상품가치가 상실된
              경우에는 교환/반품이 불가능합니다. <br />
              - 공급받으신 상품 및 용역의 내용이 표시.광고 내용과 <br />
              &nbsp; 다르거나 다르게 이행된 경우에는 공급받은 날로부터 3월이내,
              그사실을 알게 된 날로부터 30일이내
              <strong>
                <br />
                <br />
                교환 및 반품이 불가능한 경우 <br />
              </strong>
              - 고객님의 책임 있는 사유로 상품등이 멸실 또는 훼손된 경우. 단,
              상품의 내용을 확인하기 위하여 <br />
              &nbsp; 포장 등을 훼손한 경우는 제외 - 포장을 개봉하였거나 포장이
              훼손되어 상품가치가 상실된 경우
              <br />
              &nbsp; (예 : 가전제품, 식품, 음반 등, 단 액정화면이 부착된 노트북,
              LCD모니터, 디지털 카메라 등의 불량화소에 <br />
              &nbsp; 따른 반품/교환은 제조사 기준에 따릅니다.) <br />
              - 고객님의 사용 또는 일부 소비에 의하여 상품의 가치가 현저히
              감소한 경우 단, 화장품등의 경우 시용제품을 <br />
              &nbsp; 제공한 경우에 한 합니다. <br />
              - 시간의 경과에 의하여 재판매가 곤란할 정도로 상품등의 가치가
              현저히 감소한 경우
              <br />
              - 복제가 가능한 상품등의 포장을 훼손한 경우 <br />
              &nbsp; (자세한 내용은 고객만족센터 1:1 E-MAIL상담을 이용해 주시기
              바랍니다.)
              <br /> <br /> ※ 고객님의 마음이 바뀌어 교환, 반품을 하실 경우
              상품반송 비용은 고객님께서 부담하셔야 합니다. <br />
              &nbsp; (색상 교환, 사이즈 교환 등 포함)
            </span>
          </div>

          <h3>SERVICE INFO</h3>
        </div>
      </div>
    </div>
  );
}



// -----------------------------------------------------------------------------------------------






// 리뷰댓글 달기 컴포넌트
function ReivewComment(){


  // 댓글 들
  const [customerList, setCustomerList]= useState([
    {
        name: "gilldong_Hong",
        message:"만족해요. 사길 잘한 것 같아요 감사합니다🌈",
        size: "S"
    },
    {
      name: "이순신",
      message:"이뻐용 짱.",
      size: "L"
  },
    {
      name: "뚫어송태섭",
      message:"녹색옷을 그렇게 즐겨입지 않는데 선물받았는데 괜찮더라고요 요건 입을듯요",
      size: "M"
    }
 ]);


// 빈공간으로 만들어줌.
const [customer, setCustomer]=useState({
  name:'', 
  message:'',
  size: ""
});


// 이름 저장된 밸류값 받아서 넣음.
const handleName = (e)=>{
  // console.log(e.target.value);
  setCustomer((prevState)=>{
    return({...prevState, name:e.target.value});
  });
};


// 이름도 넣은 전 값 가져와서 내용 저장된 밸류값 받아서 넣음.
const handlemessage = (e)=>{
  //    console.log(e.target.value);
    setCustomer((prevState)=>{
      return({...prevState, message:e.target.value});
    });
   };


// 셀렉트
const selectList = ["사이즈 선택","S", "M", "L"];



// 셀렉트값이 체인지 될 때
const handleSelect = (e) => { 
  
  setCustomer((prevState)=>{
    return({...prevState, size: e.target.value})});
                    
};


  
  // 추가 버튼 & 리셋
  const handleCommit = (e)=>{

    if(customer.name == ""){
      alert("이름을 입력하세요")
    } else if(customer.message == ""){
      alert("내용을 입력하세요")
    }else if(customer.size == "" || customer.size == "사이즈 선택"){
      alert("사이즈를 선택하세요")
    }else{

      console.log(customer.name);
      console.log(customer.message);
      console.log(customer.size)
  
      //추가
       setCustomerList((prevState)=>{
         
           return [customer,...prevState];
       });
  
       //input 초기화
       setCustomer(()=>{
           return {name:'', message:'', size: ""};
       });
    }
    };

  

  return (
        <div className="container" style={{marginTop:"50px"}}>
        
          {/* 입력하는 곳 */}
          <div className="Comment_input_box">
            <div style={{color:"rgb(107, 107, 107)", fontWeight:"bold"}}>이름</div>
            <input type="text"
            onChange={handleName}
            value={customer.name}
            style={{ width: "70%", height: "35px" ,borderRadius:"5px", border:"1px solid #91949c" }}
            placeholder="이름을 입력하세요."
            ></input>

            <div style={{color:"rgb(107, 107, 107)", fontWeight:"bold"}}>리뷰 쓰기</div>
            <input name="message" type="text" onChange={handlemessage}
            value={customer.message}
            style={{width:"70%", height:"100px" , borderRadius:"5px", border:"1px solid #91949c"}}
            placeholder="내용을 입력하세요."
            ></input>

            <div style={{color:"rgb(107, 107, 107)", fontWeight:"bold"}}>사이즈 선택</div>
            <select onChange={handleSelect} value={customer.size} style={{width:"10%", borderRadius:"5px", border:"1px solid #91949c",}}>
              {selectList.map((item) => (
              <option value={item} key={item}>
                {item}
              </option>
              ))}
            </select>

            
            <button type="button" class="btn btn-outline-warning" style={{width:"15%", fontWeight:"bold"}}
            onClick={handleCommit}
            >리뷰 작성하기</button>
          </div>


          {/* 값나오는 곳 */}
          <div className="resultBox" >

            <div className="col-md-12">
              {customerList.map((ele,i)=>{

                return (
                  <div key={i} className="commentBox">

                    <div className="comBoxInUser">
                      <div className="userImgBox"><img src="/img/malbon_character.jpg" alt="사용자 이미지"/></div>
                      <div className="starBox2">★★★★★</div>
                      <div className="userName">{ele.name}</div>
                    </div>

                    <div className="comBoxInCom">
                      <div className="sizeBox">사이즈: {ele.size}</div>
                      <div style={{display:"flex"}}>
                        <div className="messageBox">{ele.message}</div>
                        <button type="button" class="btn btn-light" onClick={()=>{
                            let copy = [...customerList];
                            copy.splice(i,1);
                            setCustomerList(copy);

                        }} style={{width:"8%", fontSize:"13px"}}>삭제</button>
                      </div>
                      
                      <div className="small_ImgBox">
                        <div className="reviewHeart">
                          <img src="/img/comment.png"/>
                          <span>0</span>
                        </div>

                        <div className="reviewHeart">
                          <img src="/img/heart.png"/>
                          <span>0</span>
                        </div>

                        <div className="Declaration_box">
                          <img src="/img/Declaration.png"/>
                          <span>신고차단</span>
                        </div>
                      </div>

                    </div>


                  </div>
                )

              })}
            </div>

          </div>



          {/* 페이지 */}
          <nav aria-label="Page navigation example" style={{marginTop:"60px"}}>
            <ul class="pagination justify-content-center">
              <li class="page-item disabled">
                <a class="page-link" href="#" tabindex="-1">&lt;</a>
              </li>
              <li class="page-item"><a class="page-link" href="#">1</a></li>
              <li class="page-item"><a class="page-link" href="#">2</a></li>
              <li class="page-item"><a class="page-link" href="#">3</a></li>
              <li class="page-item">
                <a class="page-link" href="#">&gt;</a>
              </li>
            </ul>
          </nav>

        
        
        {/* 전체 박스 container */}
        </div>
  )

}





// 뿅 튀어나오는 컴포넌트
// function TabContent({tap}){
//   let [fade, setFade] = useState('')
//    useEffect( ()=>{
//     setTimeout(()=>{ setFade('end')},10)
//     return ()=>{
//         setFade('')
//     }
//    } ,[tap]) 
  
//   }












export default Product;
